import { useContext } from "react";
import { JsonViewProps } from "../types/common";
import DarkModeContext from "../contexes/DarkModeContext";
import { BASE_16_CUSTOM_DARK_THEME } from "../constants";

export function useReactJsonProps(
  customProps?: Partial<JsonViewProps>
): JsonViewProps {
  const darkMode = useContext(DarkModeContext);

  const defaultProps = {
    displayDataTypes: false,
    displayObjectSize: false,
    quotesOnKeys: false,
    displayArrayKey: false,
    theme: darkMode ? BASE_16_CUSTOM_DARK_THEME : "rjv-default",
  } as const;

  return {
    ...defaultProps,
    ...customProps,
  };
}
